import {useSelector} from 'react-redux';

import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

export function useSharePlanSection({onShowInfoPopover}: any) {
  const {tt, ts} = useTranslation('screen.clients.section.sharePlan');
  const featureFlag = useSelector(variablesFeatureFlag);

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Share a Plan'),
      body: tt('info.body', 'Select a plan to share with your candidates'),
    });

  return {onInfoPress, tt, ts, featureFlag};
}
